module.exports = __webpack_public_path__ + "42487a9066b015ecd10baf5f7819fa9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/drivers-voice/mask_stars.png
// module id = 870
// module chunks = 0 1